import React from 'react';

const hoverHandlers = (activeBg, idleColor) => ({
  onMouseEnter: (e) => {
    e.currentTarget.style.background = activeBg;
    e.currentTarget.style.color = '#fff';
    e.currentTarget.style.transform = 'scale(1.1)';
  },
  onMouseLeave: (e) => {
    e.currentTarget.style.background = 'rgba(255,255,255,0.95)';
    e.currentTarget.style.color = idleColor;
    e.currentTarget.style.transform = 'scale(1)';
  }
});

/**
 * 地图左下角：图源控件 + 指挥员定位（圆形按钮）
 */
export function DashboardMapLocateStack({
  bottom = 18,
  zIndex = 20,
  basemapControl = null,
  onLocateCommander
}) {
  return (
    <div style={{
      position: 'absolute',
      left: 18,
      bottom,
      zIndex,
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    }}>
      {basemapControl}
      <button
        onClick={onLocateCommander}
        style={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.95)',
          border: '2px solid #ff6b6b',
          color: '#ff6b6b',
          fontSize: 20,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          transition: 'all 0.2s ease',
          zIndex: (zIndex || 20) + 1
        }}
        {...hoverHandlers('#ff6b6b', '#ff6b6b')}
        title="定位到指挥员位置"
      >
        📍
      </button>
    </div>
  );
}

/**
 * 移动端：定位到当前/在线设备（蓝色圆形按钮）
 */
export function DashboardDeviceLocateButton({
  bottom = 18,
  zIndex = 20,
  onLocateDevice
}) {
  return (
    <div style={{
      position: 'absolute',
      left: 18,
      bottom,
      zIndex,
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    }}>
      <button
        onClick={onLocateDevice}
        style={{
          width: 44,
          height: 44,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.95)',
          border: '2px solid #1976d2',
          color: '#1976d2',
          fontSize: 18,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          transition: 'all 0.2s ease',
          zIndex: (zIndex || 20) + 1
        }}
        {...hoverHandlers('#1976d2', '#1976d2')}
        title="定位到当前设备位置"
      >
        📍
      </button>
    </div>
  );
}

export default DashboardMapLocateStack;
